(function () {
    'use strict';

    var imApp = angular.module('imApp');

    imApp.component('srUserAdmin', {
        templateUrl: 'views/components/views/srUserAdmin/srUserAdmin.template.html?v=' + imApp.version,
        controllerAs: 'vm',
        controller: ['stateService', 'dataTask0To99Service', 'srUserAdminService', function (stateService, dataTask0To99Service, srUserAdminService) {
    
            var vm = this;
    
    
    
            // ## VARIABLES & DEFINITIONS ##
    
            vm.model = {
                webPageName: stateService.getCurrentName(),
                itemsListWebPageMenu: []
            };
    
            // ## LOAD PROCEDURE CALLS ##

            // BJS 20260310 - Modified to use downgraded angular service.
            $q.when(dataTask0To99Service.dt53({
                webpageName: vm.model.webPageName
            })).then(function (data) {
                angular.copy(data, vm.model.itemsListWebPageMenu);
            });
        }]
    });
})();
